const Terminal = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.69 10.65V6.19a.25.25 0 0 0-.25-.25H3.75a.25.25 0 0 0-.25.25v4.46a.25.25 0 0 0 .25.25h5.7a.25.25 0 0 0 .24-.25zm6.56-4.71h-5.7a.25.25 0 0 0-.25.25v4.46a.25.25 0 0 0 .25.25h5.7a.25.25 0 0 0 .25-.25V6.19a.25.25 0 0 0-.25-.25zm-5.64 6.3v.42c0 .16-.28.28-.62.28s-.62-.13-.62-.28v-.42c-.94.11-1.63.47-1.63.89s1 .93 2.27.93 2.27-.42 2.27-.93-.7-.78-1.67-.88z" />
    </svg>
);

export default Terminal;
